import { render, staticRenderFns } from "./contractDialog.vue?vue&type=template&id=5245eb06&scoped=true"
import script from "./contractDialog.vue?vue&type=script&lang=js"
export * from "./contractDialog.vue?vue&type=script&lang=js"
import style0 from "./contractDialog.vue?vue&type=style&index=0&id=5245eb06&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5245eb06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5245eb06')) {
      api.createRecord('5245eb06', component.options)
    } else {
      api.reload('5245eb06', component.options)
    }
    module.hot.accept("./contractDialog.vue?vue&type=template&id=5245eb06&scoped=true", function () {
      api.rerender('5245eb06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/contract/components/contractDialog.vue"
export default component.exports